import { isValidTextInput } from '@acceligentllc/shared/utils/text';

import type { InternalFormModel } from './index';

export function validate(values: InternalFormModel) {
	const errors: ValidationErrors = {};

	if (!isValidTextInput(values.name)) {
		errors.name = 'Name is required';
	}

	return errors;
}
